// ecolabDocumentos — verificación (OCR + cruce de datos) y almacenamiento
// de documentos usando el servicio de Ecolab/Fenagro.
//
// TRANSITORIO (decisión de Antonio): CoopNet reutiliza por ahora el
// almacenamiento y el OCR de Fenagro. Mientras tanto:
//   • POST /api/ecolab/verificar-documento recibe el archivo, corre el
//     OCR (Google Vision), cruza nombre y número contra lo digitado,
//     guarda el archivo en el bucket de Fenagro y devuelve
//     { valido, mensaje, confianza, urlDocumento: 'gs://…', … }.
//   • El endpoint es público (Ecolab lo usa también en el registro de
//     afiliados, antes del login) — por eso no se envía Authorization.
//     Sin ese header es una petición "simple" de CORS (multipart), igual
//     que la del portal de Fenagro.
//
// Al hacer el corte hay que sustituir esto por el almacenamiento y la
// verificación propios de CoopNet, y migrar los archivos ya guardados
// (las URLs gs:// apuntan al bucket de Fenagro).

const ECOLAB_BASE_URL = process.env.REACT_APP_ECOLAB_BASE_URL;

/**
 * @param {File} archivo
 * @param {{ tipoDocumento: 'rut'|'cedula', numero?: string, nombres?: string, apellidos?: string }} datos
 *   Para 'rut': numero = NIT, nombres = razón social.
 *   Para 'cedula': numero = número de cédula, nombres = nombre del titular.
 * @returns {Promise<{valido:boolean, mensaje?:string, confianza?:number, urlDocumento?:string, requiereRevisionManual?:boolean}>}
 */
export async function verificarDocumentoEcolab(archivo, { tipoDocumento, numero = '', nombres = '', apellidos = '' }) {
  const formData = new FormData();
  formData.append('archivo', archivo);
  formData.append('tipoDocumento', tipoDocumento);
  if (numero) formData.append('cedula', numero); // Ecolab usa el mismo campo para NIT y cédula
  if (nombres) formData.append('nombres', nombres);
  if (apellidos) formData.append('apellidos', apellidos);

  let res;
  try {
    res = await fetch(`${ECOLAB_BASE_URL}/api/ecolab/verificar-documento`, { method: 'POST', body: formData });
  } catch {
    throw new Error('No se pudo conectar con el servicio de verificación de documentos (Ecolab).');
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.mensaje || 'Error verificando el documento.');
  return data;
}
